/** @jsx jsx */
import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { BgImage } from "gbimage-bridge"
import { jsx, Box, Container } from "theme-ui"
import Marquee from "react-fast-marquee"
import "./herosection.css"
import SingleImageLayout from "./SingleImageLayout"
import TwoImagesLayout from "./TwoImagesLayout"
import useTrackWindowSize from "../../../hooks/useTrackWindowSize"

export const query = graphql`
  fragment ContentfulHeroSectionFragment on ContentfulHeroSection {
    h1Heading
    h2Heading
    h3Heading
    h4Heading
    internalName
    imageContainerWidth
    textContainerWidth
    verticalPaddings
    content {
      raw
      references {
        ... on ContentfulAsset {
          contentful_id
          __typename
          gatsbyImageData(placeholder: NONE, resizingBehavior: SCALE)
          title
          sys {
            type
          }
        }
        ... on ContentfulWistiaItem {
          __typename
          contentful_id
          wistiaHeading
          maxVideosWidth
          videosAlignment
          videos {
            items {
              hashed_id
            }
          }
        }
      }
    }
    fontSize
    backgroundColor
    imageWidth
    textAlign
    fontColor
    imagePosition
    outOfTheBoxImage
    imageFullRight
    displayImageOnMobile
    image {
      gatsbyImageData
      file {
        contentType
        url
      }
      title
    }
    rightImage {
      gatsbyImageData
      file {
        contentType
        url
      }
      title
    }
    statsBlock {
      heading
      description
    }
    scrollingImages {
      altText
      imageTitle
      image {
        gatsbyImageData(width: 150)
      }
    }
    backgroundImage {
      gatsbyImageData
      title
    }
    buttons {
      classnameForAnalytics
      actionEvent
      fullWidth
      icon
      iconSize
      style
      label
      url
      form {
        ...FormFragment
      }
      hubspotForm {
        formId
        portalId
        region
      }
    }
    classname
    backgroundImageClassname
    wistiaItem {
      wistiaHeading
      maxVideosWidth
      videosAlignment
      videos {
        items {
          hashed_id
        }
      }
    }
  }
`

const HeroSection = ({ sectionContent }) => {
  const { content, image, rightImage, backgroundImage, scrollingImages, buttons, backgroundImageClassname } =
    sectionContent
  const { smallerScreen } = useTrackWindowSize()
  const [renderKey, setRenderKey] = useState(0)

  useEffect(() => {
    setRenderKey((prevKey) => prevKey + 1)
  }, [])

  return (
    <BgImage
      image={backgroundImage?.gatsbyImageData}
      sx={{ marginInline: "auto", overflow: "hidden" }}
      className={backgroundImageClassname ? backgroundImageClassname : ""}
    >
      {rightImage ? (
        <TwoImagesLayout sectionContent={sectionContent} key={renderKey} />
      ) : content || buttons || image ? (
        <SingleImageLayout sectionContent={sectionContent} smallScreen={smallerScreen} key={renderKey} />
      ) : null}
      {scrollingImages && (
        <Container className="hero-slider-container" sx={{ paddingBottom: "10px" }}>
          <Box sx={{ maxWidth: "1400px", marginInline: "auto" }} mt={4}>
            <Marquee speed={15}>
              {scrollingImages?.map((images, index) => (
                <Box key={index} sx={{ paddingInline: "50px" }}>
                  <GatsbyImage image={images.image.gatsbyImageData} alt={images.imageTitle} />
                </Box>
              ))}
            </Marquee>
          </Box>
        </Container>
      )}
    </BgImage>
  )
}

export default HeroSection
